import { render, staticRenderFns } from "./LastPayments.vue?vue&type=template&id=0f579856&scoped=true&"
import script from "./LastPayments.vue?vue&type=script&lang=js&"
export * from "./LastPayments.vue?vue&type=script&lang=js&"
import style0 from "./LastPayments.vue?vue&type=style&index=0&id=0f579856&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f579856",
  null
  
)

export default component.exports